module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Trash-59feb5905e376b4f4c6b992a1a2f37bf.svg";